var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const Briefcase = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M8 7.5C8 4.5 8.00001 3.5 12 3.5C16 3.5 16 4.5 16 7.5M20.354 9.22324C19.4456 7.84154 17.2597 7.5 12 7.5C6.739 7.5 4.55335 7.84171 3.64533 9.22423M20.354 9.22324C21 10.2058 21 11.7143 21 14C21 19.5 21 20.5 12 20.5C3 20.5 3 19.5 3 14C3 11.7151 3 10.2068 3.64533 9.22423M20.354 9.22324C20.354 9.22324 14 14 12 14C10 14 3.64533 9.22423 3.64533 9.22423", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
